import { createFileRoute, notFound } from '@tanstack/react-router'
import RolePageHeader from '../../Pages/RolePage/RolePageHeader'
import RolePage from '../../Pages/RolePage/RolePage'
import PageBody from '../../Pages/Layout/PageBody'
import LoadingSpinner from '../../Components/LoadingSpinner'
import ErrorComponent from '../../Components/ErrorComponent'
import { processTRPCData } from '../../Queries/fetchData'
import {
    canViewRoute,
    migratedToV2,
} from '../../State/Permissions/HasPermissions'
import SessionStore from '../../State/SessionStore'
import PermissionDenied from '../../Pages/PermissionDenied'
import DataStore from '../../State/DataStore'
import { router } from '../../App'
import RoleCollection from '../../State/Collections/RoleCollection'
import { setLayoutDefaults } from '@2/layout/layout-store'
import { getCacheItemById } from '@2/cache'
import { CenterPadPageBody } from '@2/layout/page-body'
import { RolePage as RolePageV2 } from '../../version2/pages/role-page/role-page'
import { staffRoleStore } from '../../version2/pages/role-page/role-page-store'
import { trpc } from '../../system/trpc'
import { cleanupNewEntity } from '../../Utils/deleteEntity'

export const Route = createFileRoute('/_private/staff-roles/$id')({
    beforeLoad: ({ params }) => {
        if (!canViewRoute(SessionStore.user, 'staffRole', params))
            throw new Error('Permission Denied')
        const role = getCacheItemById('roles', params.id)
        setLayoutDefaults({
            pageTitle: role?.name || 'Staff Role',
            subMenu: 'resources',
        })
    },
    errorComponent: ({ error, reset }) => {
        if (error.message === 'Permission Denied') return <PermissionDenied />
        return <ErrorComponent error={error} reset={reset} />
    },
    loader: async ({ params }) => await loader(params.id),
    pendingComponent: LoadingSpinner,
    component: Wrapper,
    onLeave: (match) => {
        const { id } = match.params
        const role = RoleCollection.rolesById[id]
        if (
            role &&
            !role.createdAt &&
            match.pathname !== router.latestLocation.pathname
        ) {
            cleanupNewEntity(role, 'role')
        }
    },
})

const loader = async (id) => {
    const data = await trpc.legacy.getRolePageData.query({ id })
    const processedModels = processTRPCData(data)
    const role = RoleCollection.rolesById[id]
    if (!role) {
        throw notFound()
    }
    return processedModels
}

function Wrapper() {
    const { id } = Route.useParams()

    // The store now handles all the save toast logic internally
    staffRoleStore.useSaveHandler()

    if (migratedToV2()) {
        return (
            <CenterPadPageBody>
                <RolePageV2 id={id} />
            </CenterPadPageBody>
        )
    }

    return (
        <>
            <RolePageHeader id={id} />
            <PageBody>
                <RolePage id={id} />
            </PageBody>
        </>
    )
}
